import { Link } from 'react-router-dom';
import './Footer.css';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__content">
                    <div className="footer__section">
                        <div className="footer__brand">
                            <img src="/icon.png" alt="VALORANTZ" className="footer__logo" />
                            <h3 className="footer__title">VALORANTZ</h3>
                        </div>
                        <p className="footer__description">
                            Your comprehensive source for VALORANT agents, weapons, and maps information.
                        </p>
                    </div>

                    <div className="footer__section">
                        <h4 className="footer__subtitle">Explore</h4>
                        <ul className="footer__links">
                            <li><Link to="/agents" className="footer__link">Agents</Link></li>
                            <li><Link to="/weapons" className="footer__link">Weapons</Link></li>
                            <li><Link to="/maps" className="footer__link">Maps</Link></li>
                        </ul>
                    </div>

                    <div className="footer__section">
                        <h4 className="footer__subtitle">Company</h4>
                        <ul className="footer__links">
                            <li><Link to="/about" className="footer__link">About Us</Link></li>
                            <li><Link to="/contact" className="footer__link">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer__section">
                        <h4 className="footer__subtitle">Resources</h4>
                        <ul className="footer__links">
                            <li><Link to="/guide" className="footer__link">Guide</Link></li>
                            <li><Link to="/faq" className="footer__link">FAQ</Link></li>
                        </ul>
                    </div>

                    <div className="footer__section">
                        <h4 className="footer__subtitle">Legal</h4>
                        <ul className="footer__links">
                            <li><Link to="/privacy" className="footer__link">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="footer__link">Terms of Service</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p className="footer__copyright">
                        © {currentYear} VALORANT
                    </p>
                </div>
            </div>
        </footer>
    );
};
